import { GeoJSONFeature } from "maplibre-gl";

import { RanaVectorTileFeature } from "@/queries/query-pmtiles-features";

// This is an array of keys that are commonly used to store the name of places inside the feature properties
// Of "Buurten NL" and "Gemeentengrenzen NL" datasets for now but can be extended in the future if needed
export const KEY_OPTIONS = ["gemeentenaam", "buurtnaam", "naam"];

export const getFeaturePlaceName = (feature: RanaVectorTileFeature | GeoJSONFeature) => {
  const properties = feature.properties;
  const foundValues: string[] = [];
  for (const keyOption of KEY_OPTIONS) {
    const match = Object.keys(properties).find((key) => key.toLowerCase() === keyOption);
    if (match) {
      foundValues.push(properties[match] as string);
    }
  }
  return foundValues.length > 0 ? foundValues.join(", ") : null;
};
